<div class="editor-wrapper">
    <div class="editor-js" #editor></div>
</div>
